<script>
    import wrappedFetch from "../../wrappedFetch.js";
    import Modal from "../components/modal.svelte";
    import ModalConfirm from "../components/modalconfirm.svelte";
    import Datepicker from 'svelte-calendar';
    import moment from "moment";
    import DataTable from "../../components/data-table.svelte";

    export let userDetails; 
    export let userHistory;
    export let showDeactivitionModal;
    
    let columnDefs =  [{ type: 'date-euro', targets: [0,1] }];
    let Histories = [];
    let oldcurrentSubscriptionRenewal, oldannualFee;
    let CustomerID = 0;

    if (userDetails){
        CustomerID = userDetails.customersID;
        oldannualFee = userDetails.annualFee;
        oldcurrentSubscriptionRenewal = userDetails.currentSubscriptionRenewal;
    }


	let start = new Date();
	let dateFormat = '#{d}/#{m}/#{Y}';
	let noWeekendsSelectableCallback = (date) => date.getDay() !== 0 && date.getDay() !== 6;
    let currrentSubscriptionStart="", currentSubscriptionRenewal="", annualFee="0";
	let dateChosen = false, dateChosen2 = false;
    $: end = new Date(start.getTime() + 1000 * 3600 * 24 * 720);

    var d = new Date();   
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();

    currrentSubscriptionStart = moment(d).format("DD/MM/YYYY");
    //currentSubscriptionRenewal = moment(new Date(year + 1, month, day)).format("DD/MM/YYYY");

    let CalendarStart = new Date(year, month - 6, day);
    let CalendarEnd = new Date(year + 6, month, day);
    let RenewalDate = new Date(year + 1, month, day);

    currentSubscriptionRenewal = moment(RenewalDate).format("DD/MM/YYYY");

    export let ShowRenewal = false;
    $: if (ShowRenewal) {
        userHistory = true;
    }

    export let ShowDeactive = false;
    $: if (ShowDeactive) {
        showDeactivition("deactive");
    }

    export async function showAllHistory() {
        CustomerID = userDetails.customersID;
        oldcurrentSubscriptionRenewal = userDetails.currentSubscriptionRenewal;
        oldannualFee = userDetails.annualFee;
        let resp = await wrappedFetch('/api/subscriptions/GetCustomerSubscriptionHistory?CustomerID=' + userDetails.customersID, {method: "get"}); 
        Histories = await resp.json();
    }

    const RenewalEstab=async()=>{
        userHistory = true;
    }

    let confirmMessage = "", confirmModalHeader = "";
    let action = "";
    const showDeactivition=async(actionType)=> {
        action = actionType;
        showDeactivitionModal = true;
        confirmModalHeader = 'Deactivate user'
        confirmMessage = `Are you sure you would like to ${action} this establishment?`
    }

    export let userDeactived = false;
    const onHandleConfirm=async()=> {
        let resp;
        if(action == "deactive")
        {
            resp = await wrappedFetch('/api/subscriptions/DeactiveSubscription?CustomerID=' + userDetails.customersID, {method: "get"}); 
        }
        handleReset();
        userDeactived = true;
    }

    export let ModalConfirmation = false;

    export let exportreset = false;
    const handleReset=async()=> {
        userHistory = false;
        showDeactivitionModal = false;
        exportreset = true;
    }
    
    const RenewEstablish=async()=> {
        const oldDate = new Date(start.getTime() + 1000 * 3600 * 24 * 720);
        var tempOld = oldDate;

        if (oldcurrentSubscriptionRenewal){
            tempOld = new Date(oldcurrentSubscriptionRenewal);
        }
        else {
            tempOld = oldDate;
        }

        var olddetails = {
            customersID: CustomerID,
            annualFee: oldannualFee,
            RenewalDate: new Date(tempOld)
        };

        var datecurrentSubscriptionRenewal = moment(currentSubscriptionRenewal, "DD/MM/YYYY");
        var newdatecurrentSubscriptionRenewal = datecurrentSubscriptionRenewal.toDate();

        var newdetails = {
            customersID: CustomerID,
            annualFee: annualFee,
            RenewalDate: new Date(newdatecurrentSubscriptionRenewal)
        };
        var data = {olddetails, newdetails};

        let resp = await wrappedFetch(
            `/api/subscriptions/UpdateRenewalDetails`,
            {
               method: "post",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        ModalConfirmation = true;
        showAllHistory();
    }
</script>

<DataTable DataLength={Histories.length} {columnDefs} message="There is currently no history to this subscription">
    <thead>
        <tr>
            <th width="33%">Subscription Start Date</th>
            <th width="33%">Subscription Renewal Date</th>
            <th width="33%">Annual Fee</th>
        </tr>
    </thead>
    <tbody>
        {#each Histories as history}
            <tr>
                <td>{history.startDatestr}</td>
                <td>{history.renewalDatestr}</td>
                <td>&pound;{history.annualFee}</td>
            </tr>
        {/each}
    </tbody>
</DataTable>

<Modal showModal={userHistory} on:close={handleReset} sizeClass="modal-md">
    <div slot="header" style="width:100%">
        <div class="row">
            <div class="col text-left"><h3 class="text-white">New subscription</h3></div>
        </div>
    </div>
    <div slot="content">
        {#if ModalConfirmation}
            <div class="alert alert-success">Your subscription has successfully been updated</div>
        {:else}
            <div class="form-group d-none">
                New Subscription Start Date
                <Datepicker bind:formattedSelected={currrentSubscriptionStart} bind:dateChosen style="width:100%" format={dateFormat}>
                    <input type="text" class="form-control" bind:value={currrentSubscriptionStart}>                        
                </Datepicker>
            </div>
            <div class="form-group">
                Current Subscription Renewal Date
                <Datepicker bind:formattedSelected={currentSubscriptionRenewal} bind:dateChosen2 style="width:100%" format={dateFormat} start={CalendarStart} end={CalendarEnd} selected={RenewalDate}>
                    <input type="text" class="form-control" bind:value={currentSubscriptionRenewal}>
                </Datepicker>
            </div>
            <div class="form-group">
                Annual Fee
                <input type="text" class="form-control" bind:value={annualFee}>
            </div>
        {/if}
    </div>
    <div slot="footer">
        {#if !ModalConfirmation}
            <button class="btn btn-primary" type="button" on:click={RenewEstablish}>Save</button>
        {/if}
    </div>
</Modal>

<ModalConfirm showModal={showDeactivitionModal} on:close={handleReset} zindex="1052" sizeClass="modal-md" targetClass="confirm-options" on:confirm={onHandleConfirm}>
    <div slot="header">  
        <h4 class="title">{confirmModalHeader}</h4>
    </div>
    <div slot="content">
        {@html confirmMessage}
    </div>
</ModalConfirm>